import { Controller, ActionEvent } from "@hotwired/stimulus";
export default class extends Controller {

  static targets = ["areaRestricted", "areaRestrictedOptions", "areaRestrictedOption", "suburbRestricted", "suburbContainer", "storeSelect", "tagSelect", "payment", "endDate"];

  PROMO_SPEND = "promotional_spend";
  INVOICE_FROM_CUSTOMER = "invoice";

  declare hasAreaRestrictedTarget: boolean;
  declare hasPaymentTarget: boolean;
  declare hasSuburbRestrictedTarget: boolean;
  declare hasSuburbContainerTarget: boolean;
  declare hasStoreSelectTarget: boolean;
  declare hasTagSelectTarget: boolean;
  declare areaRestrictedTarget: HTMLInputElement;
  declare areaRestrictedOptionsTargets: HTMLElement[];
  declare areaRestrictedOptionTargets: HTMLInputElement[];
  declare suburbRestrictedTarget: HTMLInputElement;
  declare suburbContainerTarget: HTMLElement;
  declare storeSelectTarget: HTMLSelectElement;
  declare tagSelectTarget: HTMLSelectElement;
  declare paymentTarget: HTMLSelectElement;
  declare endDateTarget: HTMLInputElement;

  connect(): void {
    if (this.hasAreaRestrictedTarget && this.hasSuburbRestrictedTarget) {
      this.applyAreaVisibility();
    }
    if (this.hasPaymentTarget) {
      this.syncEndDate(this.paymentTarget.value);
    }
  }

  disableEndDate(event: ActionEvent): void {
    this.syncEndDate((event.currentTarget as HTMLSelectElement).value);
  }

  adjustStoreSelect(event: ActionEvent) {
    event.preventDefault();

    const interpolatedNewTurboSourceUrl = event.params.url as string
    const applicableCouponsFrame = document.getElementById("applicable_coupon_products_frame")
    const requiredCouponsFrame = document.getElementById("required_coupon_products_frame")

    if (this.hasStoreSelectTarget && this.storeSelectTarget.value !== "") {
      this.tagSelectTarget.value = "";
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=${this.storeSelectTarget.value}`);
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=${this.storeSelectTarget.value}`);
    } else {
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=all_stores`);
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=all_stores`);
    }
  }

  adjustRestaurantTag(event: ActionEvent) {
    event.preventDefault();
    const interpolatedNewTurboSourceUrl = event.params.url as string
    const requiredCouponsFrame = document.getElementById("required_coupon_products_frame")
    const applicableCouponsFrame = document.getElementById("applicable_coupon_products_frame")

    if (this.hasTagSelectTarget && this.tagSelectTarget.value !== "") {
      this.storeSelectTarget.value = "";
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=${this.tagSelectTarget.value}`);
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=${this.tagSelectTarget.value}`);
    } else {
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=all_stores`);
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=all_stores`);
    }
  }

  applyLocationFilters(): void {
    this.applyAreaVisibility();
    this.hideAllSuburbFrames();

    if (this.areaRestrictedTarget.checked && this.suburbRestrictedTarget.checked) {
      this.areaRestrictedOptionTargets.filter(el => el.checked).forEach(el => this.showSuburbFrame(el.dataset.areaId!));
    }
  }

  applyAreaFilter(event: ActionEvent): void {
    if (!this.suburbRestrictedTarget.checked) return;
    const checkbox = event.currentTarget as HTMLInputElement;
    const areaId = checkbox.dataset.areaId!;
    if (checkbox.checked) {
      this.showSuburbFrame(areaId);
    } else {
      this.hideSuburbFrame(areaId);
    }
  }

  private applyAreaVisibility(): void {
    if (this.areaRestrictedTarget.checked) {
      for (const child of this.areaRestrictedOptionsTargets) child.classList.remove('is-hidden');
    } else {
      for (const child of this.areaRestrictedOptionsTargets) child.classList.add('is-hidden');
      this.suburbRestrictedTarget.checked = false;
    }
  }

  private showSuburbFrame(areaId: string): void {
    const frame = document.getElementById(`coupon_suburb_area_${areaId}`);
    frame?.removeAttribute("disabled");
    frame?.classList.remove("is-hidden");
  }

  private hideSuburbFrame(areaId: string): void {
    this.suburbContainerTarget?.querySelector(`#coupon_suburb_area_${areaId}`)?.classList?.add("is-hidden");
  }

  private hideAllSuburbFrames(): void {
    this.suburbContainerTarget?.querySelectorAll("turbo-frame").forEach(frame => {
      frame.classList.add("is-hidden");
    });
  }

  private syncEndDate(value: string): void {
    const date = new Date();

    if (value === this.INVOICE_FROM_CUSTOMER) {
      date.setFullYear(date.getFullYear() + 3);
      this.endDateTarget.value = date.toISOString().split("T")[0];
      this.endDateTarget.readOnly = true;
    } else if (value === this.PROMO_SPEND) {
      date.setMonth(date.getMonth() + 3);
      this.endDateTarget.value = date.toISOString().split("T")[0];
      this.endDateTarget.readOnly = false;
    } else {
      this.endDateTarget.readOnly = false;
    }
  }
}
